module.exports = __webpack_public_path__ + "img/icon_red_left.48959717.svg";